import { useEffect, useState } from 'react';
import { isEmpty } from '../utils/utils';
import { useSnackbar } from 'notistack';
import { useLazyQuery } from '@apollo/client';
import CustomError from '../components/CustomError/CustomError';
import { handleGraphQLError } from './utils';

function useNRQuery({ query, options, qlObjKey, transformData, defaultValue }) {
  const [total, setTotal] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [result, setResult] = useState(defaultValue);

  const [customLoading, setCustomLoading] = useState(true);

  const [callQuery, { loading, error, data, called, fetchMore }] = useLazyQuery(query, {
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    ...options,
    onCompleted: data => {
      try {
        if (options?.onCompleted) {
          options.onCompleted(data);
        }
      } finally {
        setCustomLoading(false);
      }
    },
    onError: error => {
      setCustomLoading(false);
      if (options?.onError) {
        options.onError(error);
      }
    }
  });

  useEffect(() => {
    try {
      callQuery(options);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (data && data[qlObjKey]) {
      if (data[qlObjKey] && data[qlObjKey].items) {
        setResult(!!transformData ? transformData(data[qlObjKey].items) : data[qlObjKey].items);
      } else {
        setResult(!!transformData ? transformData(data[qlObjKey]) : data[qlObjKey]);
      }
      if (data[qlObjKey].pageInfo) {
        if (data[qlObjKey]?.pageInfo?.totalSize != null) {
          setTotal(data[qlObjKey].pageInfo.totalSize);
        }
        if (data[qlObjKey]?.pageInfo?.totalCount != null) {
          setTotal(data[qlObjKey].pageInfo.totalCount);
        }
      }
      if (data[qlObjKey].totalCount != null) {
        setTotal(data[qlObjKey].totalCount);
      }
    }
  }, [data]);

  useEffect(() => {
    if (loading) {
      setResult(defaultValue);
    }
  }, [loading]);

  const handleFetchMore = queryParams => {
    if (called && fetchMore) {
      callQuery({
        variables: { ...queryParams }
      });
    }
  };

  useEffect(() => {
    if (error) {
      handleGraphQLError({
        error,
        enqueueSnackbar,
        onFinally: () => setCustomLoading(false)
      });
    }
  }, [error]);

  return [result, customLoading, handleFetchMore, total, called, error];
}

export default useNRQuery;
